export const buildSettlementsFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue Name',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
  {
    id: 'event',
    label: 'Event',
    filters: [
      {
        id: 'event_name',
        label: 'Event Name',
        type: 'search',
        options: (filterOptions.event_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
  {
    id: 'payment',
    label: 'Payment',
    filters: [
      {
        id: 'payment_status',
        label: 'Payment Status',
        type: 'checkbox',
        options: [
          { value: 'Paid', label: 'Paid' },
          { value: 'Unpaid', label: 'Unpaid' },
        ],
      },
      {
        id: 'payment_method',
        label: 'Payment Method',
        type: 'checkbox',
        options: (filterOptions.payment_method_options || []).map(o => ({
          value: o,
          label: o,
        })),
      },
    ],
  },
];
